import React from 'react';
import PeriodicTableResume from './periodictableresume';

function App() {
  return (
    <div className="App">
      <PeriodicTableResume />
    </div>
  );
}

export default App;